import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/atoms/seo"
import PageTitle from "../components/atoms/page-title/page-title"
import PageDivider from "../components/atoms/page-divider/page-divider"
import AvocatSection from "../components/molecules/avocat-section/avocat-section"
import SubtitleDescription from "../components/atoms/subtitle-description/subtitle-description"
import AvocatContentJeanPaul from "../components/molecules/avocat-content/avocat-content-jean-paul"

const EquipePage = () => {
  const { allWordpressPage } = useStaticQuery(
    graphql`
      query {
        allWordpressPage(filter: { title: { eq: "equipe-presentation" } }) {
          edges {
            node {
              id
              title
              content
            }
          }
        }
      }
    `
  )
  return (
    <>
      <Layout>
        <SEO title="Mopo Avocats Equipe" />
        <PageTitle title="équipe" />
        <SubtitleDescription>
          {allWordpressPage.edges[0]?.node.content && (
            <div
              dangerouslySetInnerHTML={{
                __html: allWordpressPage.edges[0]?.node.content,
              }}
            />
          )}
        </SubtitleDescription>
        <PageDivider />
        <AvocatSection name="maître Jean-Paul MOPO" who="jp">
          <AvocatContentJeanPaul />
        </AvocatSection>
      </Layout>
    </>
  )
}

export default EquipePage
